export const JUST_LOCATIONS_SAVE = 'JUST_LOCATIONS_SAVE';
